<wiz-translation-basic
  #fdlevelTrans
  wizValidator
  width="200px"
  wizMaxChars="20"
  [wizShowErrors]="true"
  [wizMandatory]="true"
></wiz-translation-basic>
